module.exports = __webpack_public_path__ + "images/sns_campaign_lp/mainvisual-date-pc_586d517c5fe5f9e170fdaf87f01f882b.png";